<template>
    <div class="row">1</div>
</template>

<script>
export default {
    mounted() {},
};
</script>
